import FullScreenForm from "./views/pages/FullScreenForm.vue";

export const settingsRoutes = [
    {
        path: '/full-form/:bundle/:definition/:objectId?/:relationString?',
        component: FullScreenForm,
        name: 'full-form',
        meta: {
            title: 'Full Screen Form',
        }
    },
];